export default __webpack_public_path__ + "static/bncff-app-1-83b72ce5041194e009b9102fbf7710d0.jpg";